import Vue from "vue";
import router from './router'
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate';

import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        eventId : null,

        currentRoute : '',
        currentRouteIndex : 0,
        routeHistory : [],

        isPrimaryTreatmentVisible : false,
        isPrimaryTreatmentResultsVisible : false,

        patientsList : [],

        patient : {
            id : null,

            stageError : '',
            image : '',
            shortImage : '',

            mainInfo : {
                gender : '',
                ageRange : '',
                name : ''
            },

            oldGenderAge : {
                gender : '',
                ageRange : ''
            },

            iPS : '',

            illHistoryPoints : {
                isExtraExercise : '',
                isBasePetKt : '',
                isBSymptoms : ''
            },

            basePetKtResult : '',
            himResult : '',

            primaryPetABVDKtResult : '',
            primaryPetBEACOPPKtResult : '',

            primaryABVDKtResult : '',
            primaryBEACOPPKtResult : '',

            biopsyResult : '',

            anamnesResult : '',
            fertilAnamnesResult : [],
            byEffect : '',

            fertilAnamnezInPatientResultPage : [],

            isDoctorSetAvd : false,
            isDoctorSetOther : false,
            isDoctorSetBEACOPP : false,
            isDoctorSetAdditionResearch : false
        }
    },
    plugins: [createPersistedState({ storage: window.sessionStorage })],
    getters: {
        getPrimaryTreatmentVisible: state => {
            return state.isPrimaryTreatmentVisible;
        },
        getPrimaryTreatmentResultsVisible: state => {
            return state.isPrimaryTreatmentResultsVisible;
        },

        getIsSimplePatient: state => {
            let age = state.patient.mainInfo.ageRange;
            return state.patient.mainInfo.gender === 'Чоловік' && (age === '18-30' || age === '31-40' || age === '41-50' || age === '51-60') || state.patient.mainInfo.gender === 'Жінка' && age === '51-60';
        },
        getIsOldPatient: state => {
            let age = state.patient.mainInfo.ageRange;
            let gender = state.patient.mainInfo.gender;

            return (gender === 'Чоловік' && age === '60+') || (gender === 'Жінка' && age === '60+');
        },
        getIsFertilGirl: state => {
            let age = state.patient.mainInfo.ageRange;
            return state.patient.mainInfo.gender === 'Жінка' && (age === '18-30' || age === '31-40');
        },
        getIsOlderFertilGirl: state => {
            return state.patient.mainInfo.gender === 'Жінка' && state.patient.mainInfo.ageRange === '41-50';
        },

        getFertilAnamnezInPatientResultPage: state => {
            return state.patient.fertilAnamnezInPatientResultPage;
        },


        getEventId: state => {
            return state.eventId;
        },
        getCurrentRoute: state => {
            return state.currentRoute;
        },
        getPatientName : state => {
            return state.patient.mainInfo.name;
        },
        getPatientAge: state => {
            return state.patient.mainInfo.ageRange;
        },
        getCurrentRouteIndex: state => {
            return state.currentRouteIndex;
        },
        getIPS: state => {
            return state.patient.iPS;
        },
        getIllHistoryPoints: state => {
            return state.patient.illHistoryPoints;
        },
        getIsBasePetKt: state => {
            return state.patient.illHistoryPoints.isBasePetKt === 'Результат базової ПЕТ-КТ';
        },
        getBasePetKtResult: state => {
            return state.patient.basePetKtResult;
        },
        getHimResult: state => {
            return state.patient.himResult;
        },
        getPrimaryPetABVDKtResult: state => {
            return state.patient.primaryPetABVDKtResult;
        },
        getPrimaryPetBEACOPPKtResult: state => {
            return state.patient.primaryPetBEACOPPKtResult;
        },
        getPrimaryABVDKtResult: state => {
            return state.patient.primaryABVDKtResult;
        },
        getPrimaryBEACOPPKtResult: state => {
            return state.patient.primaryBEACOPPKtResult;
        },
        getBiopsyResult: state => {
            return state.patient.biopsyResult;
        },
        getAnamnesResult: state => {
            return state.patient.anamnesResult;
        },
        getFertilAnamnesResult: state => {
            return state.patient.fertilAnamnesResult;
        },
        getByEffect: state => {
            return state.patient.byEffect;
        },
    },
    mutations: {
        setEventId(state, eventId){
            state.eventId = eventId;
        },
        setCurrentRoute(state, route){
            state.currentRoute = route;
        },
        setCurrentRouteIndex(state, index){
            state.currentRouteIndex = index;
        },
        removeStageError(state){
            state.patient.stageError = '';
        },
        setGender(state, gender){
            state.patient.mainInfo.gender = gender;
        },
        setAge(state, age){
            state.patient.mainInfo.ageRange = age;
        },
        setPatientName(state, name){
            state.patient.mainInfo.name = name;
        },
        setIPS(state, value){
            state.patient.iPS = value;
        },
        setIllHistory(state, value){
            state.patient.illHistoryPoints = value;
        },
        setBasePetKtResult(state, value){
            state.patient.basePetKtResult = value;
        },
        setHimResult(state, value){
            state.patient.himResult = value;
        },
        setPrimaryPetABVDKtResult(state, value){
            state.patient.primaryPetABVDKtResult = value;
        },
        setPrimaryPetBEACOPPKtResult(state, value){
            state.patient.primaryPetBEACOPPKtResult = value;
        },
        setPrimaryABVDKtResult(state, value){
            state.patient.primaryABVDKtResult = value;
        },
        setPrimaryBEACOPPKtResult(state, value){
            state.patient.primaryBEACOPPKtResult = value;
        },
        setBiopsyResult(state, value){
            state.patient.biopsyResult = value;
        },
        setAnamnesResult(state, value){
            state.patient.anamnesResult = value;
        },
        setFertilAnamnesResult(state, value){
            state.patient.fertilAnamnesResult.push(value);
        },
        resetFertilAnamnes(state){
            state.patient.fertilAnamnesResult.splice(0, state.patient.fertilAnamnesResult.length);
        },
        setByEffect(state, value){
            state.patient.byEffect = value;
        },

        setFertilAnamnezInPatientResultPage(state, value){
            for(let i = 0; i < value.length; i++){
                state.patient.fertilAnamnezInPatientResultPage.push(value[i]);
            }
        },

        setIsDoctorSetAvd(state, value){
            state.patient.isDoctorSetAvd = value;
        },
        setIsDoctorSetOther(state, value){
            state.patient.isDoctorSetOther = value;
        },
        setIsDoctorSetBEACOPP(state, value){
            state.patient.isDoctorSetBEACOPP = value;
        },
        setIsDoctorSetAdditionResearch(state, value){
            state.patient.isDoctorSetAdditionResearch = value;
        },

        resetPatient(state){
            state.currentRoute = '/create-patient/stage/1';
            state.currentRouteIndex = 0;
            state.routeHistory = [];

            state.isPrimaryTreatmentVisible = false;
            state.isPrimaryTreatmentResultsVisible = false;

            state.patient.id = null;
            state.patient.stageError = '';
            state.patient.image = '';
            state.patient.shortImage = '';

            state.patient.mainInfo = {
                gender : '',
                ageRange : '',
                name : ''
            };

            state.patient.oldGenderAge = {
                gender : '',
                ageRange : ''
            }
            state.patient.iPS = '';
            state.patient.illHistoryPoints = {
                isExtraExercise : '',
                isBasePetKt : '',
                isBSymptoms : ''
            }

            state.patient.basePetKtResult = '';
            state.patient.himResult = '';
            state.patient.primaryPetABVDKtResult = '';
            state.patient.primaryPetBEACOPPKtResult = '';
            state.patient.primaryABVDKtResult = '';
            state.patient.primaryBEACOPPKtResult = '';
            state.patient.biopsyResult = '';
            state.patient.anamnesResult = '';
            state.patient.fertilAnamnesResult = [];
            state.patient.byEffect = '';

            router.push(state.currentRoute);
        },
        fullRresetPatient(state){
            state.currentRoute = '';
            state.currentRouteIndex = 0;
            state.routeHistory = [];

            state.isPrimaryTreatmentVisible = false;
            state.isPrimaryTreatmentResultsVisible = false;

            state.patient.id = null;
            state.patient.stageError = '';
            state.patient.image = '';
            state.patient.shortImage = '';

            state.patient.mainInfo = {
                gender : '',
                ageRange : '',
                name : ''
            };

            state.patient.oldGenderAge = {
                gender : '',
                ageRange : ''
            }
            state.patient.iPS = '';
            state.patient.illHistoryPoints = {
                isExtraExercise : '',
                isBasePetKt : '',
                isBSymptoms : ''
            }

            state.patient.basePetKtResult = '';
            state.patient.himResult = '';
            state.patient.primaryPetABVDKtResult = '';
            state.patient.primaryPetBEACOPPKtResult = '';
            state.patient.primaryABVDKtResult = '';
            state.patient.primaryBEACOPPKtResult = '';
            state.patient.biopsyResult = '';
            state.patient.anamnesResult = '';
            state.patient.fertilAnamnesResult = [];
            state.patient.byEffect = '';
        },

        prevStage(state){
            if(state.currentRouteIndex > 0){
                state.patient.stageError = '';
                state.currentRouteIndex--;

                if(state.currentRoute === '/create-patient/stage/2'){
                    state.patient.mainInfo.name = '';
                }

                else if(state.currentRoute === '/create-patient/man/18-60/1'){
                    state.patient.iPS = '';
                }

                else if(state.currentRoute === '/create-patient/man/18-60/2'){
                    state.patient.illHistoryPoints = {
                        isExtraExercise : '',
                        isBasePetKt : '',
                        isBSymptoms : ''
                    };
                }

                else if(state.currentRoute === '/create-patient/man/18-60/2/isBaseKt'){
                    state.patient.basePetKtResult = '';
                }

                else if(state.currentRoute === '/create-patient/man/18-60/2/him'){
                    state.isPrimaryTreatmentVisible = false;
                    state.patient.himResult = '';
                }

                else if(state.currentRoute === '/create-patient/man/18-60/2/him/kt/1'){
                    state.isPrimaryTreatmentResultsVisible = false;
                    state.patient.primaryPetABVDKtResult = '';
                    state.patient.primaryABVDKtResult = '';        
                }

                else if(state.currentRoute === '/create-patient/man/18-60/2/him/kt/2'){
                    state.isPrimaryTreatmentResultsVisible = false;
                    state.patient.primaryPetBEACOPPKtResult = '';
                    state.patient.primaryBEACOPPKtResult = '';
                }

                else if(state.currentRoute === '/create-patient/anamnes'){
                    state.patient.anamnesResult = '';
                }

                else if(state.currentRoute === '/create-patient/fertil-anamnes'){
                    state.patient.fertilAnamnesResult = [];
                    state.patient.fertilAnamnezInPatientResultPage = [];
                }

                else if(state.currentRoute === '/create-patient/by-effect/1'){
                    state.patient.byEffect = '';
                }

                else if(state.currentRoute === '/create-patient/biopsy-result'){
                    state.patient.biopsyResult = '';
                }

                let routeToMove = state.routeHistory.pop();
                state.currentRoute = routeToMove;
                router.push(routeToMove);
            }
        }
    },
    actions: {
        async sendResultsToServer({ state }){
            axios.post('/api/Doctor/SetPatientIllHistory', state.patient)
            .then(response => {
                console.log(response);
            })
            .catch(e => {
                console.log(e);
                console.log(e.message)
            })
        },
        async nextStage({ dispatch, state }){
            console.log(state.currentRoute);
            if(state.currentRouteIndex === 0){
                await dispatch('checkStage1');
            }

            else if(state.currentRouteIndex === 1){
                dispatch('checkStage2');
            }

            else if(state.currentRoute === '/create-patient/man/18-60/1'){
                dispatch('checkIPS');
            }

            else if(state.currentRoute === '/create-patient/man/18-60/2'){
                dispatch('checkIllHistory');
            }

            else if(state.currentRoute === '/create-patient/man/18-60/2/isBaseKt'){
                dispatch('checkBasePetKtResult');
            }

            else if(state.currentRoute === '/create-patient/man/18-60/2/him'){
                dispatch('checkHimResult');
            }

            else if(state.currentRoute === '/create-patient/man/18-60/2/him/kt/1'){
                dispatch('checkKt1');
            }

            else if(state.currentRoute === '/create-patient/man/18-60/2/him/kt/2'){
                dispatch('checkKt2');
            }

            else if(state.currentRoute === '/create-patient/anamnes'){
                dispatch('checkAnamnes');
            }

            else if(state.currentRoute === '/create-patient/fertil-anamnes'){
                dispatch('checkFertilAnamnes');
            }

            else if(state.currentRoute === '/create-patient/by-effect/1'){
                dispatch('checkByEffect1');
            }

            else if(state.currentRoute === '/create-patient/biopsy-result'){
                dispatch('checkBiopsyResult');
            }
        },
        async checkStage1({ state }){
            if(state.patient.mainInfo.gender !== '' && state.patient.mainInfo.ageRange !== ''){
                if(state.patient.mainInfo.gender !== state.patient.oldGenderAge.gender || state.patient.mainInfo.ageRange !== state.patient.oldGenderAge.ageRange){
                    let data = new FormData();

                    data.append('gender', state.patient.mainInfo.gender);
                    data.append('ageRange', state.patient.mainInfo.ageRange);
                    data.append('eventId', state.eventId);
                    
                    if(state.patient.id === null){
                        let newPatientResponse = await axios.post('/api/Doctor/CreateNewPatient', data);            
                        state.patient.id = newPatientResponse.data.id;
                        state.patient.image = newPatientResponse.data.patientsImage.image;
                        state.patient.shortImage = newPatientResponse.data.patientsImage.shortImage;

                        console.log(state.patient.shortImage)
                    }
                    else{
                        data.append('patientId', state.patient.id);
                        let getImageResponse = await axios.post('/api/Doctor/GetFreeImage', data);
                        state.patient.image = getImageResponse.data.image;
                        state.patient.shortImage = getImageResponse.data.shortImage;

                        console.log(state.patient.shortImage)
                    }
                    
                    let gender = state.patient.mainInfo.gender;
                    let age = state.patient.mainInfo.ageRange;

                    state.patient.oldGenderAge.gender = gender;
                    state.patient.oldGenderAge.ageRange = age;
                }

                state.currentRouteIndex++;
                let routeIndex = state.currentRouteIndex + 1;
                state.routeHistory.push('/create-patient/stage/1');
                state.currentRoute = '/create-patient/stage/' + routeIndex;
                router.push(state.currentRoute);

                state.patient.stageError = '';
            }
            else if(state.patient.mainInfo.gender == '' && state.patient.mainInfo.ageRange === ''){
                state.patient.stageError = 'Щоб продовжити, вкажіть стать та вік пацієнта';
            }
            else if(state.patient.mainInfo.ageRange === ''){
                state.patient.stageError = 'Щоб продовжити, вкажіть вік пацієнта';
            }
            else{
                state.patient.stageError = 'Щоб продовжити, вкажіть стать пацієнта';
            }
        },
        async checkStage2({ state }){
            state.patient.mainInfo.name = state.patient.mainInfo.name.trim();
            let isCorrectName = /^[A-Za-z\s\-/`/ /]+$/.test(state.patient.mainInfo.name) || /^[А-Яа-яёЁЇїІіЄєҐґ\-/'//-/ /]+$/.test(state.patient.mainInfo.name);

            if(state.patient.mainInfo.name === ''){
                state.patient.stageError = 'Щоб перейти далі, введіть ім’я';
            }
            else if(!isCorrectName){
                console.log('In uncorrect name error');
                state.patient.stageError = 'Введіть коректне ім’я';
            }
            else{
                state.patient.stageError = '';

                let data = new FormData();

                data.append('name', state.patient.mainInfo.name);
                data.append('patientId', state.patient.id);

                await axios.post('/api/Doctor/AddNameToPatient', data);

                state.currentRouteIndex++;
                state.routeHistory.push('/create-patient/stage/2');
                state.currentRoute = '/create-patient/man/18-60/1';
                router.push(state.currentRoute);

                console.log(state.currentRoute);
            }
        },
        checkIPS({ state }){
            if(state.patient.iPS === ''){
                state.patient.stageError = 'Щоб продовжити, вкажіть значення IPS';
            }
            else{
                state.patient.stageError = '';
                state.currentRouteIndex++;
                state.routeHistory.push('/create-patient/man/18-60/1');
                state.currentRoute = '/create-patient/man/18-60/2';
                router.push(state.currentRoute);

                console.log(state.currentRoute);
            }
        },
        checkIllHistory({ state }){
            let illHistory = state.patient.illHistoryPoints;

            if(!illHistory.isExtraExercise)
                state.patient.illHistoryPoints.isExtraExercise = 'Відсутні екстранодальні ураження';
            if(!illHistory.isBasePetKt)
                state.patient.illHistoryPoints.isBasePetKt = 'Відсутній результат базової ПЕТ-КТ';
            if(!illHistory.isBSymptoms)
                state.patient.illHistoryPoints.isBSymptoms = 'Відсутні В-симптоми';

            state.currentRouteIndex++;

            if(state.patient.illHistoryPoints.isBasePetKt === 'Результат базової ПЕТ-КТ'){
                // state.currentRouteProgress += 11;
                state.currentRoute = '/create-patient/man/18-60/2/isBaseKt';
            }
            else{
                state.isPrimaryTreatmentVisible = true;
                state.currentRoute = '/create-patient/man/18-60/2/him';
            }

            state.routeHistory.push('/create-patient/man/18-60/2');
            router.push(state.currentRoute);
        },
        checkBasePetKtResult({ state }){
            if(state.patient.basePetKtResult === ''){
                state.patient.stageError = 'Щоб продовжити, вкажіть результат базової ПЕТ-КТ';
            }
            else{
                state.isPrimaryTreatmentVisible = true;

                state.patient.stageError = '';
                state.currentRouteIndex++;
                state.routeHistory.push('/create-patient/man/18-60/2/isBaseKt');
                state.currentRoute = '/create-patient/man/18-60/2/him';
                router.push(state.currentRoute);
            }
        },
        checkHimResult({ state, getters }){
            state.patient.stageError = '';

            let himResult = state.patient.himResult;
            if(himResult === '')
                state.patient.stageError = 'Щоб продовжити, вкажіть, яке лікування отримував пацієнт';
            else if(himResult === '2 курси ABVD'){
                state.isPrimaryTreatmentResultsVisible = true;
                state.currentRoute = '/create-patient/man/18-60/2/him/kt/1';
            }
            else if(himResult === '2 курси escBEACOPP'){
                state.isPrimaryTreatmentResultsVisible = true;
                state.currentRoute = '/create-patient/man/18-60/2/him/kt/2';
            }
            else if(himResult === 'Не отримував хіміотерапію'){
                if(getters.getIsFertilGirl || getters.getIsOlderFertilGirl){
                    state.currentRoute = '/create-patient/fertil-anamnes';
                }
                else{
                    state.currentRoute = '/create-patient/anamnes';
                }
            }
            
            console.log(state.currentRoute);

            if(!state.patient.stageError){
                
                state.currentRouteIndex++;
                state.routeHistory.push('/create-patient/man/18-60/2/him');
                router.push(state.currentRoute);
            }            
        },
        checkKt1({ state, getters }){
            state.patient.stageError = '';
            let isBasePetKt = state.patient.illHistoryPoints.isBasePetKt === 'Результат базової ПЕТ-КТ';

            if(isBasePetKt){
                
                if(state.patient.primaryPetABVDKtResult === '')
                    state.patient.stageError = 'Щоб продовжити, вкажіть результат проміжної оцінки терапії за даними ПЕТ-КТ';
                else{
                    if(getters.getIsOldPatient && state.patient.primaryPetABVDKtResult === 'D5'){
                        state.currentRoute = '/patient-results';
                    }
                    else if((getters.getIsFertilGirl || getters.getIsOlderFertilGirl) && state.patient.primaryPetABVDKtResult === 'D5'){
                        state.currentRoute = '/create-patient/fertil-anamnes';
                    }
                    else{
                        state.currentRoute = '/create-patient/by-effect/1';
                    }                    
                }
            }
            else{
                if(state.patient.primaryABVDKtResult === '')
                    state.patient.stageError = 'Щоб продовжити, вкажіть результат проміжної оцінки терапії за даними КТ';
                else{
                    if(getters.getIsOldPatient && state.patient.primaryABVDKtResult === 'Прогресія'){
                        state.currentRoute = '/patient-results';
                    }
                    else if((getters.getIsFertilGirl || getters.getIsOlderFertilGirl) && state.patient.primaryABVDKtResult === 'Прогресія'){
                        state.currentRoute = '/create-patient/fertil-anamnes';
                    }
                    else{
                        state.currentRoute = '/create-patient/by-effect/1';
                    }                    
                }
            }

            console.log(!state.patient.stageError);
            
            if(!state.patient.stageError){
                if(state.currentRoute !== '/patient-results'){
                    state.currentRouteIndex++;
                    state.routeHistory.push('/create-patient/man/18-60/2/him/kt/1');
                    router.push(state.currentRoute);
                }
                else{
                    state.currentRoute = '/create-patient/man/18-60/2/him/kt/1';
                    router.push('/patient-results');
                }
            }            
        },
        checkKt2({ state }){
            state.patient.stageError = '';
            let isBasePetKt = state.patient.illHistoryPoints.isBasePetKt === 'Результат базової ПЕТ-КТ';

            if(isBasePetKt){
                console.log(state.patient);
                if(state.patient.primaryPetBEACOPPKtResult === '')
                    state.patient.stageError = 'Щоб продовжити, вкажіть результат проміжної оцінки терапії за даними ПЕТ-КТ';
                else if(state.patient.primaryPetBEACOPPKtResult === 'D5')
                    state.currentRoute = '/create-patient/biopsy-result';
                else{
                    state.currentRoute = '/create-patient/by-effect/1';
                }
            }
            else{
                if(state.patient.primaryBEACOPPKtResult === '')
                    state.patient.stageError = 'Щоб продовжити, вкажіть результат проміжної оцінки терапії за даними КТ';
                else if(state.patient.primaryBEACOPPKtResult === 'Прогресія')
                    state.currentRoute = '/create-patient/biopsy-result';
                else
                    state.currentRoute = '/create-patient/by-effect/1';
            }

            if(!state.patient.stageError){
                state.currentRouteIndex++;
                state.routeHistory.push('/create-patient/man/18-60/2/him/kt/2');
                router.push(state.currentRoute);
            }
        },
        checkAnamnes(){
            // state.currentRouteIndex++;
            // state.routeHistory.push('/create-patient/anamnes');
            // state.currentRoute = '/patient-results';
            // router.push(state.currentRoute);
            router.push('/patient-results');
        },
        checkFertilAnamnes(){
            // state.currentRouteIndex++;
            // state.routeHistory.push('/create-patient/fertil-anamnes');
            // state.currentRoute = '/patient-results';
            // router.push(state.currentRoute);
            router.push('/patient-results');
        },
        checkByEffect1(){
            // state.currentRouteIndex++;
            // state.routeHistory.push('/create-patient/by-effect/1');
            // state.currentRoute = '/patient-results';
            // router.push(state.currentRoute);
            router.push('/patient-results');
        },
        checkBiopsyResult({ state }){
            state.patient.stageError = '';

            if(state.patient.biopsyResult === ''){
                state.patient.stageError = 'Щоб продовжити, вкажіть результат біопсії після проміжного ПЕТ-КТ';
            }
            else{
                // state.currentRouteIndex++;
                // state.routeHistory.push('/create-patient/biopsy-result');
                // state.currentRoute = '/patient-results';
                // router.push(state.currentRoute);
                router.push('/patient-results');
            }
        }
    }
});